// extracted by mini-css-extract-plugin
module.exports = {"stackItem":"Stack_stackItem__fNgV_"};